import React, { useCallback } from 'react'
import moment from 'moment'

import { DeleteButton } from 'src/legacy/components/mui'
import { GetPatientHistoryTypesDocument } from 'src/participantHistoryForm/getPatientHistoryTypes.generated'
import { GetParticipantVideoCallBookingInformationDocument } from 'src/videoCall/VideoCallBookingHeader/videoCallBookingHeaderQueries.generated'
import { GetUncancelledInProgramCallsDocument } from 'src/participantHistoryForm/form/checkinCall/getUncancelledInProgramCalls.generated'
import { FetchParticipantsForHomeViewDocument } from 'src/participantsHome/searchParticipants.generated'
import {
  GetPatientHistoryAndProgramStartDateDocument,
  useDeletePatientHistoryMutation,
} from '../patientHistoryQueries.generated'

const PARTICIPANT_HISTORY_DELETION_PERIOD_IN_HOURS = 48

type Props = {
  createdAt: string | Date
  entryID: string
  uid: string
  source?: string | null
}

const ParticipantHistoryDelete = ({ createdAt, entryID, uid, source }: Props) => {
  const [deletePatientHistory] = useDeletePatientHistoryMutation({
    refetchQueries: [
      GetPatientHistoryAndProgramStartDateDocument,
      {
        query: GetPatientHistoryTypesDocument,
        variables: { uid },
      },
      // Keep check-in call banner in sync: videoCalls excludes calls that already have a note.
      {
        query: GetParticipantVideoCallBookingInformationDocument,
        variables: { uid },
      },
      {
        query: GetUncancelledInProgramCallsDocument,
        variables: { uid },
      },
      // Deleting a note can make a completed call await a note again, and only the server
      // knows that, so let it recalculate the patient list's call follow-up indicator.
      FetchParticipantsForHomeViewDocument,
    ],
  })

  const handleDeletePatientHistory = useCallback(async () => {
    await deletePatientHistory({ variables: { entryID } })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deletePatientHistory])

  if (
    moment().diff(moment(createdAt), 'hours') <= PARTICIPANT_HISTORY_DELETION_PERIOD_IN_HOURS &&
    source === 'dashboard'
  ) {
    return <DeleteButton onDelete={handleDeletePatientHistory} title="Delete Entry" />
  }
  return null
}

export default ParticipantHistoryDelete
